'use memo';

import { create } from 'zustand';
type RefreshPollingState = {
  isBoosting: boolean;
  startBoost: () => void;
};
type CreateRefreshPollingStoreOptions = {
  durationMs: number;
};
export function createRefreshPollingStore({
  durationMs
}: CreateRefreshPollingStoreOptions) {
  return create<RefreshPollingState>(set => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    return {
      isBoosting: false,
      startBoost: () => {
        if (timeoutId != null) {
          clearTimeout(timeoutId);
        }
        set({
          isBoosting: true
        });
        timeoutId = setTimeout(() => {
          set({
            isBoosting: false
          });
          timeoutId = null;
        }, durationMs);
      }
    };
  });
}